import { Color, media } from '../../styles';
import styled from 'styled-components';

interface Props {
  backgroundColor: Color;
  fullWidth?: boolean;
  textColor: string;
}

export default styled.button<Props>`
  align-items: center;
  content: none;
  background: ${({ backgroundColor }) => backgroundColor.default};
  border: none;
  border-radius: ${({ theme }) => theme.ui.buttons.borderRadius};
  color: ${({ textColor }) => textColor};
  display: flex;
  justify-content: center;
  flex: 1 1 auto;
  font-size: ${({ theme }) => theme.typography.size.medium};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  outline: none;
  padding: ${({ theme }) => `${theme.spacing.base.sm} ${theme.spacing.base.md}`};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};

  &:focus {
    background: ${({ backgroundColor }) => backgroundColor.dark};
  }

  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }

  &:hover {
    background: ${({ backgroundColor }) => backgroundColor.dark};
  }

  ${media.mobilePortrait} {
    padding: ${({ theme }) => `${theme.spacing.mobile.md} ${theme.spacing.mobile.md}`};
  }

  ${media.mobileLandscape} {
    padding: ${({ theme }) => `${theme.spacing.mobile.md} ${theme.spacing.mobile.md}`};
  }
`;
